import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-748261de"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "front"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-container"
}, null, -1));
const _hoisted_4 = {
  class: "icon",
  width: "16",
  height: "16",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  "data-v-042ca774": ""
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352zm0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288zm0 64a224 224 0 110 448 224 224 0 010-448zm0 64a160.192 160.192 0 00-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160z"
}, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  t: "1645672863518",
  width: "16",
  height: "16",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2032"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M398.592 801.365333l-82.389333-22.101333 33.578666-125.397333a468.821333 468.821333 0 0 1-138.112-79.872l-91.861333 91.904-60.373333-60.373334 91.904-91.861333a467.498667 467.498667 0 0 1-101.162667-216.32l83.968-15.317333C166.528 461.312 323.370667 597.333333 512 597.333333c188.586667 0 345.472-136.021333 377.856-315.306666l83.968 15.274666a467.498667 467.498667 0 0 1-101.12 216.362667l91.861333 91.861333-60.373333 60.373334-91.861333-91.904a468.821333 468.821333 0 0 1-138.112 79.872l33.578666 125.44-82.389333 22.058666-33.621333-125.44a472.405333 472.405333 0 0 1-159.573334 0l-33.621333 125.44z",
  "p-id": "2033"
}, null, -1));
const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = {
  class: "button-area"
};
import { ref, unref, reactive, nextTick, getCurrentInstance, computed } from 'vue';
import { login, getCaptchaImage } from '@/utils/api';
import { ElMessage } from 'element-plus';
import { UserFilled, Lock, HelpFilled } from '@element-plus/icons-vue';
export default {
  __name: 'login',
  setup(__props) {
    const footer = computed(() => store.getters.footer);
    const {
      proxy
    } = getCurrentInstance();
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('username cannot be empty'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 5) {
        callback(new Error('password cannot less than 5 digits'));
      } else {
        callback();
      }
    };
    const validateCaptcha = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('Verification Code cannot be empty'));
      } else {
        callback();
      }
    };
    const captchaLoading = ref(true);
    const loading = ref(false);
    const showDialog = ref(false);
    const capsTooltip = ref(false);
    const loginForm = reactive({
      username: '',
      password: '',
      code: '',
      uuid: ''
    });
    const loginRules = reactive({
      username: [{
        required: true,
        validator: validateUsername
      }],
      password: [{
        required: true,
        validator: validatePassword
      }],
      code: [{
        required: true,
        validator: validateCaptcha
      }]
    });
    const redirect = undefined;
    const passwordType = ref('password');
    const otherQuery = ref({});
    const captchaImageSrc = ref('');
    const validUsername = str => {
      var reg = /^\s*$/;
      return !reg.test(str);
    };
    const checkCapslock = e => {
      const {
        key
      } = e;
      capsTooltip.value = key && key.length === 1 && key >= 'A' && key <= 'Z';
    };
    const password = ref();
    const showPwd = () => {
      passwordType.value = unref(passwordType) === 'password' ? '' : 'password';
      nextTick(() => {
        unref(password).focus();
      });
    };
    const form = ref(null);
    const handleLogin = () => {
      form.value.validate(valid => {
        if (valid) {
          loading.value = true;
          let {
            username,
            password,
            code,
            uuid
          } = loginForm;
          login({
            username,
            password,
            code,
            uuid
          }).then(res => {
            ElMessage.success('Login Success');
            sessionStorage.setItem('token', res.token);
            // this.$store.dispatch('user/getInfo',)
            // .then(()=>{
            // this.$router.push({ path: this.redirect || '/admin', query: this.otherQuery })
            proxy.$router.push({
              path: '/admin'
            });
            loading.value = false;
            // })
          }).catch(e => {
            getCaptchaImage();
          }).finally(e => {
            loading.value = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    };
    const getOtherQuery = query => {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    };
    const getCaptchaImage2 = () => {
      captchaImageSrc.value = '';
      getCaptchaImage().then(res => {
        captchaImageSrc.value = res.img || res.captchaOnOff === false ? `data:image/gif;base64,${res.img}` : '';
        loginForm.uuid = res.uuid;
      });
    };
    const captchaError = success => {
      if (success) return;
      captchaLoading.value = true;
      console.log('加载失败,10秒后重试');
      setTimeout(() => {
        getCaptchaImage2();
      }, 10000);
    };
    getCaptchaImage2();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
        ref_key: "form",
        ref: form,
        model: loginForm,
        rules: loginRules,
        class: "login-form",
        autocomplete: "on",
        "label-position": "left",
        "label-width": "100"
      }, {
        default: _withCtx(() => [_hoisted_3, _createVNode(_component_el_form_item, {
          label: "Username",
          prop: "username"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: loginForm.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => loginForm.username = $event),
            type: "text",
            "prefix-icon": _unref(UserFilled),
            placeholder: 'Please input your username'
          }, null, 8, ["modelValue", "prefix-icon"])]),
          _: 1
        }), _createVNode(_component_el_tooltip, {
          modelValue: capsTooltip.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => capsTooltip.value = $event),
          content: "Caps lock is On",
          placement: "right",
          manual: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "password",
            label: "Password"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: loginForm.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => loginForm.password = $event),
              type: passwordType.value,
              "prefix-icon": _unref(Lock),
              autocomplete: "new-password",
              placeholder: 'Please input your password'
            }, null, 8, ["modelValue", "type", "prefix-icon"]), _createElementVNode("span", {
              class: "show-pwd",
              onClick: showPwd
            }, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6, 512)), [[_vShow, passwordType.value === 'password']]), _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9, 512)), [[_vShow, passwordType.value !== 'password']])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_row, {
          type: "flex",
          align: "middle",
          justify: "space-between"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 17
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "ValidateCode",
              prop: "code"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: loginForm.code,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => loginForm.code = $event),
                type: "text",
                "prefix-icon": _unref(HelpFilled),
                autocomplete: "new-password",
                placeholder: 'Please input code'
              }, null, 8, ["modelValue", "prefix-icon"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6,
            style: {
              "margin-bottom": "30px"
            }
          }, {
            default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", {
              class: "login-code",
              "element-loading-background": "rgba(255, 255, 255, 0)",
              onClick: getCaptchaImage2
            }, [_createVNode(_component_el_image, {
              src: captchaImageSrc.value,
              class: "login-code-img"
            }, null, 8, ["src"])])), [[_directive_loading, captchaImageSrc.value == '']])]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
          loading: loading.value,
          class: "submit-btn",
          onClick: handleLogin
        }, {
          default: _withCtx(() => [_createTextVNode(" Login ")]),
          _: 1
        }, 8, ["loading"])])]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
};